module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec05_pc_2c7cad2fb816025eb576477c667265c9.jpg";